var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"data-source":_vm.types,"columns":_vm.columns,"pagination":false,"scroll":{x: 600}},scopedSlots:_vm._u([{key:"type",fn:function(type, record){return _c('a',{},[_c('a-avatar',{attrs:{"src":record.image}}),_vm._v(" "+_vm._s(type)+" ")],1)}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }